module.exports = __webpack_public_path__ + "static/media/8marketing.38b42e02.jpg";